<template>
  <div class="onboarding-seeker bg-grey-background-subdued">
    <ProgressBar :value="progress.currentStep" :max="progress.totalSteps" :content="progressContent" />
    <RouteStepper
      class="w-full mt-32 max-w-688 px-16 mx-auto"
      :hide-breadcrumb="false"
      breadcrumb-container-class="mx-auto w-full max-w-536"
      :model-value="initialDraftData"
      @progress="progress = $event"
      @submit="submit"
    />
  </div>
</template>

<script lang="ts">
import RouteStepper from '@/components/route_stepper/RouteStepper.vue';
import ProgressBar from '@/components/progress_bar/ProgressBar.vue';
import { CorporateOnboardingGuidedDraft } from './types';

export default {
  name: 'CorporateOnboardingGuided',
  components: { RouteStepper, ProgressBar },
  data(): { progress: { currentStep: number; totalSteps: number }; entryQueryParams: any } {
    return {
      progress: { currentStep: 1, totalSteps: 1 },
      entryQueryParams: {},
    };
  },
  computed: {
    progressContent(): string {
      return `Step ${this.progress.currentStep} of ${this.progress.totalSteps}`;
    },
    initialDraftData(): CorporateOnboardingGuidedDraft {
      return {};
    },
  },
  created() {
    this.entryQueryParams = { ...this.$route.query };
  },
  methods: {
    submit(data: any): void {
      console.warn('submit', data);
    },
  },
};
</script>

<style lang="scss">
.onboarding-seeker .card:not(.card-preserve) {
  padding: 24px;

  @media (max-width: 480px) {
    background-color: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}
</style>
